import { ScheduleActivityCostCodeCostTypeBase } from './base/schedule-activity-cost-code-cost-type-base';

export class ScheduleActivityCostCodeCostType extends ScheduleActivityCostCodeCostTypeBase { }